let canExecCommandCopy;

function clickHandler() {
    const text = this.getAttribute('data-clipboard-text');

    // Create a temp textarea: we use it to copy the text
    const tempTextarea = document.createElement('textarea');

    tempTextarea.value = text;

    // Some style to be sure that this textarea is invisible (but still selectable)
    tempTextarea.style.fontSize = '12pt';
    tempTextarea.style.border = '0';
    tempTextarea.style.padding = '0';
    tempTextarea.style.margin = '0';
    tempTextarea.style.position = 'absolute';
    tempTextarea.style.color = 'transparent';
    tempTextarea.style.backgroundColor = 'transparent';
    tempTextarea.setAttribute('readonly', '');

    this.parentNode.insertBefore(tempTextarea, this);

    // Select textarea content (ie. the text we want to copy)
    tempTextarea.focus();
    tempTextarea.setSelectionRange(0, text.length);

    // Copy selected text
    document.execCommand('copy');

    // And remove textarea to keep our DOM clean
    this.parentNode.removeChild(tempTextarea);
}

export function enableCopyToElement(element, string) {
    element.setAttribute('data-clipboard-text', string);
    element.removeEventListener('click', clickHandler);
    element.addEventListener('click', clickHandler);
}

export function isEnabled() {
    if (canExecCommandCopy === undefined) {
        canExecCommandCopy = !!(document.queryCommandSupported && document.queryCommandSupported('copy'));
    }

    return canExecCommandCopy;
}

export default { enableCopyToElement, isEnabled };
